module.exports = __webpack_public_path__ + "img/service_revenue_icon.f6378fb6.svg";